import { useSelector } from 'react-redux';
import { selectAuthState } from '../auth/AuthSelectors';
export const useAuthState = () => {
  const authState = useSelector(selectAuthState);
  const user = authState && authState.user;
  const portal = authState && authState.portal;
  const portalId = portal && portal.portal_id;
  const hasBetaAccess = user && user.scopes.includes('beta-admin-access');
  return {
    user,
    portal,
    portalId,
    hasBetaAccess
  };
};